<template>
    <div>
        <div class="g-mt-8 g-mb-6" style="text-align:center">
            <img :src="PLACEHOLDER_IMAGE" width="160px" />
        </div>

        <g-row class="g-mb-7">
            <g-column :span="24" class="g-mb-5">
                <g-typography tag="h2" font-weight="semibold" size="h1" text-align="center" marginClass="mb-20">
                    Enjoy instant payouts with zero fees
                </g-typography>
            </g-column>

            <g-column :span="24">
                <g-typography tag="p" size="p" text-align="center" color="grey-6">
                    Spend your money without delay
                </g-typography>
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-7">
            <g-column :span="18">
                <g-steps
                    direction="vertical"
                >
                    <g-step
                        v-for="(info, i) in GRIN_CARD_BENEFITS_INFO"
                        :key="i"
                        :title="info.title"
                        :description="info.description"
                        status="finish"
                    />
                </g-steps>
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-6">
            <g-column :span="17">
                <g-button
                    shape="round"
                    theme="live"
                    type="primary"
                    block
                    size="large"
                    @click="$emit('continue')">
                    Continue
                </g-button>
            </g-column>
        </g-row>
        <g-row type="flex" align="middle" justify="space-around" class="g-mb-4">
            <g-column>
                <g-link type="normal" @click="$emit('back')">Go Back</g-link>
            </g-column>
        </g-row>
    </div>
</template>

<script>
    import { PLACEHOLDER_IMAGE } from '../../../../../app-v2/constants/cdn-assets';
    import { GRIN_CARD_BENEFITS_INFO } from '../../../../../app-v2/constants/payouts';

    export default {
        name: "GrinCardInfo",

        setup() {
            return {
                PLACEHOLDER_IMAGE,
                GRIN_CARD_BENEFITS_INFO,
            };
        },
    };
</script>

<style lang="scss" scoped>
::v-deep .ant-steps .ant-steps-item-title {
    font-size:14px;
    line-height:21px;
    font-weight:500;
    margin-bottom:0.5rem;
}

::v-deep .ant-steps .ant-steps-item-description {
    padding-bottom:1.5rem;
}

::v-deep .ant-steps-item-tail::after {
    width:0 !important;
}
</style>
